module.exports = __webpack_public_path__ + "static/media/1019001BE.b7247139.jpg";